import Container from "../components/Container";

export default function Contact() {
    return <>
        <Container
            transparent
            padding={""}
            shadow={false}
            size={"w-full"}
            className="relative"
            outerPadding={""}
        >
            <div className={`min-w-[100vw] md:min-w-[80dvw]`}>
                <img className="h-[90dvh] w-full object-cover "
                     src="img/musa-ortac-HrrWNCpoOu8-unsplash.jpg" alt="cover-image"/>

                <div
                    className="absolute inset-0 bg-gradient-to-br from-gray-700 to-slate-900 opacity-70"></div>

                <div
                    className="absolute bottom-0 right-0 w-full flex flex-col md:flex-row justify-between items-center">
                    <div
                        className={"pt-24 pb-8 md:pb-16 px-6 md:px-10 space-y-6 text-center md:text-left text-white  rounded-3xl"}>
                        <div>
                            <div className={"font-bold text-2xl md:text-5xl"}>Contact Us</div>
                        </div>
                        <div className={"md:text-lg md:font-semibold"}>
                            We are empowering the real estate stakeholder ecosystem with innovative tools and advanced
                            technologies to support their growth.
                        </div>
                    </div>
                </div>
            </div>
        </Container>

        <Container className={"md:grid md:grid-cols-3 gap-4"} transparent shadow={false} padding={""}>
            <Container wrapperClassName={"col-span-2 w-full"}>
                <div className="flex gap-4">
                    <div className={"flex-1"}>
                        <input
                            className={"bg-blue-100 placeholder:text-blue-400 border border-blue-500 focus:bg-blue-200 focus:border-blue-900 outline-0 rounded-2xl py-2 px-4 w-full"}
                            placeholder={"Email Address"}/>
                    </div>

                    <div className={"flex-1"}>
                        <input
                            className={"bg-blue-100 placeholder:text-blue-400 border border-blue-500 focus:bg-blue-200 focus:border-blue-900 outline-0 rounded-2xl py-2 px-4 w-full"}
                            placeholder={"Phone Number"}/>
                    </div>
                </div>

                <div className={"my-4"}>
                    <input
                        className={"bg-blue-100 placeholder:text-blue-400 border border-blue-500 focus:bg-blue-200 focus:border-blue-900 outline-0 rounded-2xl py-2 px-4 w-full"}
                        placeholder={"Full Name"}/>
                </div>

                <div className={"mt-4"}>
                    <textarea
                        rows={5}
                        className={"bg-blue-100 placeholder:text-blue-400 border border-blue-500 focus:bg-blue-200 focus:border-blue-900 outline-0 rounded-2xl py-2 px-4 w-full"}
                        placeholder={"Message"}/>
                </div>

                <div>
                    <button className={"bg-blue-500 hover:bg-blue-600 py-2 px-8 rounded-2xl text-white uppercase font-semibold transition-all"}>
                        Submit
                    </button>
                </div>
            </Container>

            <Container className={"w-full bg-blue-500 text-white"}>
                <div className={"space-y-4"}>
                    <h2 className={"text-3xl font-bold text-center"}>Our Newsletter</h2>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Illo minima obcaecati praesentium
                        quasi unde. Aperiam dolor facere facilis fugiat id impedit, suscipit voluptates. Animi
                        doloremque non odio possimus recusandae sit?
                    </p>
                </div>


                <div className={"my-6"}>
                    <input
                        className={"bg-blue-100 placeholder:text-blue-400 border border-blue-500 focus:bg-blue-200 focus:border-blue-900 outline-0 rounded-2xl py-2 px-4 w-full"}
                        placeholder={"Email Address"}/>
                </div>

                <div className={"mt-6 flex flex-col"}>
                    <button className={"bg-blue-950 hover:bg-blue-900 text-white py-2 px-6 rounded-2xl uppercase font-semibold transition-all"}>
                        Subscribe
                    </button>
                </div>

            </Container>
        </Container>
    </>
}